import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, take, takeUntil, timeout } from 'rxjs/operators';
import { DataSourcesEnum } from 'src/app/enums/DataSourcesEnum';
import { ElectionStatusEnum } from 'src/app/enums/ElectionStatusEnum';
import { PageTypeEnum } from 'src/app/enums/PageTypeEnum';
import { IReportTurnout } from 'src/app/interfaces/IReportTurnout';
import { ISelectPage } from 'src/app/interfaces/ISelectPage';
import { ElectionService } from 'src/app/services/election.service';


@Component({
  selector: 'turnout-by-district',
  templateUrl: './turnout-by-district.component.html',
  styleUrls: ['./turnout-by-district.component.scss']
})
export class TurnoutByDistrictComponent implements AfterViewInit, OnDestroy {
  @Input() district = 'State';

  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  public turnout: IReportTurnout | null = null;
  public title = 'Essential Data';
  public docket = 'HA';
  public isFinal = false;

  constructor(private electionService: ElectionService) {
    this.electionService.dataLoaded$.pipe(takeUntil(this.componentDestroyed$)).subscribe(dataLoaded => {
      if (this.isDataLoaded(dataLoaded.electionDate)) {
        this.loadChart(this.electionService.selectedPage);
      }
    });
    this.electionService.pageChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe(page => {
      this.loadChart(page);
    });
  }

  private isDataLoaded(electionDateString: string): boolean {
    const election = this.electionService.electionMap.get(electionDateString);
    if (election) {
      return election.dataSourceTrigger([
        DataSourcesEnum.HAChange,
        DataSourcesEnum.HAStatic
      ]);
    }
    return false;
  }

  ngAfterViewInit(): void {
    if (this.isDataLoaded(this.electionService.selectedPage.electionDateString ?? '')) {
      this.loadChart(this.electionService.selectedPage);
    }
  }

  private loadChart(page: ISelectPage): void {
    const election = this.electionService.electionMap.get(page.electionDateString ?? '');
    this.isFinal = election?.haChange?.electionStatus === ElectionStatusEnum.final;
    if (page.pageType === PageTypeEnum.CountHAStateWide) {

      this.turnout = {
        electorsEnrolled: election?.electionCount?.totalEnrolled ?? 0,
        votesCast: election?.electionCount?.totalVostesCast ?? 0,
        votesCounted: election?.electionCount?.totalVostesCast ?? 0,
        formalVotes: election?.electionCount?.totalFormalVotes ?? 0,
        informalVotes: election?.electionCount?.totalInformalVotes ?? 0,
        formalPercent: election?.electionCount?.formalVotesPercent ?? 0,
        informalPercent: election?.electionCount?.informalVotesPercent ?? 0,
        turnoutPercent: election?.electionCount?.turnoutPercent ?? 0,
        isProvisional: true,
        reportingRegion: '',
        informality: 0
      };
    }
    if (page.pageType === PageTypeEnum.CountHADistrict) {

      const foundDistrict = election?.electionCount?.getDistrict(page.countDistrict);
      if (foundDistrict) {
        this.turnout = {
          electorsEnrolled: foundDistrict.districtEnrolled ?? 0,
          votesCast: foundDistrict.districtTotalVotesCast ?? 0,
          votesCounted: foundDistrict.districtTotalVotesCast ?? 0,
          formalVotes: foundDistrict.districtTotalFormalVotes ?? 0,
          informalVotes: foundDistrict.districtInformalVotes ?? 0,
          formalPercent: foundDistrict.districtFormalVotesPercent ?? 0,
          informalPercent: foundDistrict.districtInformalVotesPercent ?? 0,
          turnoutPercent: foundDistrict.districtTurnoutPercent ?? 0,
          isProvisional: true,
          reportingRegion: '',
          informality: 0
        };
      }
    }
  }


  // private getTurnout(election: Election){
    // if(election.inProgress == true){
    //   this.currentData.getTurnout(this.configs.currentData, election.electionType, this.district, this.docket)
    //   .pipe(timeout(60000), catchError(error => of('Request timed out')))
    //   .pipe(take(1))
    //   .subscribe(v => {
    //     if(v != 'Request timed out'){
    //       this.turnout = v;
    //     }
    //   });
    // }
    // else{
    //   this.historicData.getTurnout(this.configs.historicData, election.electionType, election.electionDate, this.district, this.docket)
    //   .pipe(timeout(60000), catchError(error => of('Request timed out')))
    //   .pipe(take(1))
    //   .subscribe(v => {
    //     if(v != 'Request timed out'){
    //       this.turnout = v;
    //     }
    //   });
    // }

  // }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

}
